import { Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';
import { AccountConfigService } from '../../services/account-config/account-config.service';
import { DemandeEncadrementService } from '../../services/demande-encadrement/demande-encadrement.service';
import { MUser } from '@argalis-apps/models';
import { AuthService } from '../../../auth/services/auth/auth.service';

@Component({
  selector: 'ags-demandes-encadrement-list',
  templateUrl: './demandes-encadrement-list.component.html',
  styleUrls: ['./demandes-encadrement-list.component.scss']
})
export class DemandesEncadrementListComponent implements OnInit {
  @HostBinding('class') themeFlag: string;
  public demandes: any[] = [];
  public headerBackground = 'no-style-applied';
  public headerColor = 'no-style-applied';
  public bodyBackground = 'no-style-applied';
  public bodyColor = 'no-style-applied';
  public isLoaded: boolean;
  private userConnected: MUser.CUser = null;
  @Output() public demandesOutput = new EventEmitter<any[]>();
  @Output() public goToDetailOutput = new EventEmitter<number>();

  @Input('header-background')
  set _headerBackground(uikitColor: string) {
    switch (uikitColor) {
      case 'muted':
        this.headerBackground = 'uk-background-muted';
        break;
      case 'primary':
        this.headerBackground = 'primary-background';
        break;
      case 'secondary':
        this.headerBackground = 'secondary-background';
        break;
      case 'primary-darker':
        this.headerBackground = 'primary-background-darker';
        break;
      case 'secondary-darker':
        this.headerBackground = 'secondary-background-darker';
        break;
      case 'primary-lighter':
        this.headerBackground = 'primary-background-lighter';
        break;
      case 'secondary-lighter':
        this.headerBackground = 'secondary-background-lighter';
        break;
      default:
        break;
    }
  }

  @Input('header-color')
  set _headerColor(color: string) {
    switch (color) {
      case 'primary':
        this.headerColor = 'primary-color';
        break;
      case 'secondary':
        this.headerColor = 'secondary-color';
        break;
      case 'alert':
        this.headerColor = 'alert-color';
        break;
      case 'basic':
        this.headerColor = 'basic-text';
        break;
      case 'colored':
        this.headerColor = 'colored-text';
        break;
      default:
        break;
    }
  }

  @Input('body-background')
  set _bodyBackground(color: string) {
    switch (color) {
      case 'muted':
        this.bodyBackground = 'uk-background-muted';
        break;
      case 'primary':
        this.bodyBackground = 'primary-background';
        break;
      case 'secondary':
        this.bodyBackground = 'secondary-background';
        break;
      case 'primary-darker':
        this.bodyBackground = 'primary-background-darker';
        break;
      case 'secondary-darker':
        this.bodyBackground = 'secondary-background-darker';
        break;
      case 'primary-lighter':
        this.bodyBackground = 'primary-background-lighter';
        break;
      case 'secondary-lighter':
        this.bodyBackground = 'secondary-background-lighter';
        break;
      default:
        break;
    }
  }

  @Input('body-color')
  set _bodyColor(color: string) {
    switch (color) {
      case 'primary':
        this.bodyColor = 'primary-color';
        break;
      case 'secondary':
        this.bodyColor = 'secondary-color';
        break;
      case 'alert':
        this.bodyColor = 'alert-color';
        break;
      case 'basic':
        this.bodyColor = 'basic-text';
        break;
      case 'colored':
        this.bodyColor = 'colored-text';
        break;
      default:
        break;
    }
  }

  constructor(
    private accountService: AccountConfigService,
    private demandeService: DemandeEncadrementService,
    private authService: AuthService
  ) {
    this.themeFlag = `${this.themeFlag || ''} ${accountService.themingClassName}`;
    this.userConnected = this.authService.userConnected;
  }

  ngOnInit() {
    const idIntervenant = this.userConnected.userInfo.id;
    this.demandeService.getListById(idIntervenant).subscribe(
      (res: any) => {
        if (!res) {
          // this.getTestData(); // données de test
        } else {
          this.demandes = res;
        }
        this.emitNotificationNumber();
        this.isLoaded = true;
      },
      err => {
        // this.getTestData(); // données de test
        this.isLoaded = true;
      }
    );
  }

  getTestData() {
    const sampleDemande = {
      id: 42,
      dateValid: '12/12/2019', // date format dd/MM/YYYY
      title: 'Calculs et fonctionnalités avancées sous Excel 2016',
      referenceProduit: 'PRT-00026',
      referenceSession: 'SES-170564',
      referenceInterne: 'Excel N2 Paris',
      dateBegin: '11/12/2019',
      dateEnd: '12/12/2019',
      lieuName: 'Novotel Paris-Les-Halles',
      lieuAddress: '8 place Marguerite de Navarre, 75001 Paris',
      nameResponsible: 'Hélène DURAND',
      urlAccept:
        'https://back.argalis.fr/api/validationsession/intervenant/argalis_recette/1Vso41tt6oTK4YE-uTx9N-jZ/false/true',
      urlRefuse:
        'https://back.argalis.fr/api/validationsession/intervenant/argalis_recette/1Vso41tt6oTK4YE-uTx9N-jZ/false/false',
      planning: []
    };
    this.demandes = [sampleDemande, sampleDemande, sampleDemande, sampleDemande, sampleDemande, sampleDemande];
    this.emitNotificationNumber();
  }

  emitNotificationNumber() {
    this.demandesOutput.emit(this.demandes);
  }

  seeDetails(index: number) {
    const idSession = (this.demandes[index] || {}).id;
    this.goToDetailOutput.emit(Number(idSession || 0));
  }

  refuse(index: number) {
    window.open(`${this.demandes[index].urlRefuse}`);
    this.demandes.splice(index, 1);
    this.emitNotificationNumber();
  }

  accept(index: number) {
    window.open(`${this.demandes[index].urlAccept}`);
    this.demandes.splice(index, 1);
    this.emitNotificationNumber();
  }
}
